const CheckAllIcon = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="2"
      y="2"
      width="16"
      height="16"
      rx="5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M22 6V17C22 19.7614 19.7614 22 17 22H6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7 10L9 12L13 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { CheckAllIcon };
